import { useSyncExternalStore } from 'react';

export type CscaExplanationLanguage = 'CN' | 'ID';

const STORAGE_KEY = 'csca-explanation-language';

let fallbackLanguage: CscaExplanationLanguage = 'CN';
const CHANGE_EVENT = 'csca-explanation-language-change';
const readLanguage = (): CscaExplanationLanguage => {
  try { return window.localStorage.getItem(STORAGE_KEY) === 'ID' ? 'ID' : 'CN'; }
  catch { return fallbackLanguage; }
};
const subscribeLanguage = (notify: () => void) => {
  window.addEventListener('storage', notify);
  window.addEventListener(CHANGE_EVENT, notify);
  return () => { window.removeEventListener('storage', notify); window.removeEventListener(CHANGE_EVENT, notify); };
};
export function useCscaExplanationLanguage() {
  const language = useSyncExternalStore(subscribeLanguage, readLanguage, () => 'CN' as const);
  const changeLanguage = (next: CscaExplanationLanguage) => {
    fallbackLanguage = next;
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch { /* Storage may be unavailable. */ }
    window.dispatchEvent(new Event(CHANGE_EVENT));
  };
  return { language, changeLanguage };
}

export default function CscaExplanationLanguageSwitch({
  language,
  onChange,
}: {
  language: CscaExplanationLanguage;
  onChange: (language: CscaExplanationLanguage) => void;
}) {
  return (
    <div role="group" aria-label="解析语言 / Bahasa pembahasan" className="inline-flex rounded-xl border border-indigo-200 bg-white p-1">
      {(['CN', 'ID'] as const).map(value => (
        <button
          key={value}
          type="button"
          aria-pressed={language === value}
          onClick={() => onChange(value)}
          className={`rounded-lg px-4 py-2 text-sm font-bold transition-colors ${language === value ? 'bg-indigo-600 text-white' : 'text-indigo-700 hover:bg-indigo-50'}`}
        >
          {value}
        </button>
      ))}
    </div>
  );
}
